var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68046 5.80828V1.93609C9.68046 0.871242 8.80922 0 7.74437 0C6.67952 0 5.80828 0.871242 5.80828 1.93609V5.80828H1.93609C0.871242 5.80828 0 6.67952 0 7.74437C0 8.80922 0.871242 9.68046 1.93609 9.68046H5.80828V13.5526C5.80828 14.6175 6.67952 15.4887 7.74437 15.4887C8.80922 15.4887 9.68046 14.6175 9.68046 13.5526V9.68046H13.5526C14.6175 9.68046 15.4887 8.80922 15.4887 7.74437C15.4887 6.67952 14.6175 5.80828 13.5526 5.80828H9.68046Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusReport);
export default __webpack_public_path__ + "static/media/plusReport.dffd20f26f3bc205305ab7906f08e240.svg";
export { ForwardRef as ReactComponent };